// Event types for type safety

export const AnalyticsEvents = {
  // Order Events
  ORDER_CREATED: "order-created",
  ORDER_FREE_CREATED: "order-free-created",
  ORDER_PAYMENT_INITIATED: "order-payment-initiated",
  ORDER_PAYMENT_SUCCESS: "order-payment-success",
  ORDER_PAYMENT_FAILED: "order-payment-failed",
  ORDER_PAYMENT_REINITIATED: "order-payment-reinitiated",
  ORDER_SONG_DOWNLOADED: "order-song-downloaded",
  ORDER_CANCEL_CLICKED: "order-cancel-clicked",
  ORDER_CANCELLED: "order-cancelled",
  ORDER_CANCEL_ERROR: "order-cancel-error",
  ORDER_RESUME_PAYMENT_CLICKED: "order-resume-payment-clicked",
  ORDER_RESUME_PAYMENT_ERROR: "order-resume-payment-error",

  ORDER_DRAFT_PICK_AGE: "order-draft-pick-age",
  ORDER_DRAFT_PICK_GENDER: "order-draft-pick-gender",
  ORDER_DRAFT_SEND_MESSAGE: "order-draft-send-message",
  ORDER_DRAFT_FINISH_STORY_NOW: "order-draft-finish-story-now",
  ORDER_DRAFT_RETRY_STORY_NOW: "order-draft-retry-story-now",
  ORDER_DRAFT_SAVED_CHILD_SELECTED: "order-draft-saved-child-selected",
  ORDER_DRAFT_NAME_VALID: "order-draft-name-valid",
  ORDER_DRAFT_NAME_INVALID: "order-draft-name-invalid",
  ORDER_DRAFT_NAME_UNKNOWN: "order-draft-name-unknown",
  ORDER_DRAFT_NAME_SUGGESTION_CLICKED: "order-draft-name-suggestion-clicked",
  ORDER_DRAFT_STEPPER_CLICKED: "order-draft-stepper-clicked",
  ORDER_DRAFT_BACK_CLICKED: "order-draft-back-clicked",
  ORDER_DRAFT_NEXT_CLICKED: "order-draft-next-clicked",

  ORDER_UNPAID_POPUP_SHOWN: "order-unpaid-popup-shown",
  ORDER_UNPAID_POPUP_DISMISSED: "order-unpaid-popup-dismissed",
  ORDER_UNPAID_POPUP_RESUME_PAYMENT_CLICKED:
    "order-unpaid-popup-resume-payment-clicked",

  GIFT_DOWNLOADED: "gift-downloaded",
  GIFT_PAGE_LISTEN_CLICKED: "gift-page-listen-clicked",
  GIFT_PAGE_OPEN_CLICKED: "gift-page-open-clicked",

  // Form Events
  CONTACT_FORM_SUBMITTED: "contact-form-submitted",
  NEWSLETTER_SUBSCRIBED: "newsletter-subscribed",

  // User Events
  USER_LOGIN: "user-login",
  USER_LOGIN_EMAIL_CLICKED: "user-login-email-clicked",
  USER_LOGIN_GOOGLE_CLICKED: "user-login-google-clicked",
  USER_LOGOUT: "user-logout",
  USER_MENU_OPENED: "user-menu-opened",
  USER_MENU_CLICKED_CANTECELE: "user-menu-clicked-cantecele",
  USER_MENU_CLICKED_COMENZI: "user-menu-clicked-comenzi",
  USER_MENU_CLICKED_PROFIL: "user-menu-clicked-profil",
  USER_MENU_CLICKED_ADMIN: "user-menu-clicked-admin",
  USER_MENU_CLICKED_INAPOI: "user-menu-clicked-inapoi",
  USER_MENU_CLICKED_REIA_PLATA: "user-menu-clicked-reia-plata",
  USER_MENU_CLICKED_DECONECTARE: "user-menu-clicked-deconectare",

  // Theme Events
  THEME_SWITCHED_TO_DARK: "theme-switched-to-dark",
  THEME_SWITCHED_TO_LIGHT: "theme-switched-to-light",
  THEME_SWITCHED_TO_SYSTEM: "theme-switched-to-system",

  // Versuri Events
  VERSURI_SEARCH: "versuri-search",
  VERSURI_EXIT_INTENT_POPUP_SHOWN: "versuri-exit-intent-popup-shown",
  VERSURI_EXIT_INTENT_POPUP_CTA_CLICK: "versuri-exit-intent-popup-cta-click",
  VERSURI_EXIT_INTENT_POPUP_DISMISSED: "versuri-exit-intent-popup-dismissed",
  VERSURI_DRIVE: "versuri-drive",
  VERSURI_STICKY_FOOTER_SHOWN: "versuri-sticky-footer-shown",
  VERSURI_STICKY_FOOTER_CLICK: "versuri-sticky-footer-click",
  VERSURI_FONT_SIZE_INCREASE: "versuri-font-size-increase",
  VERSURI_FONT_SIZE_DECREASE: "versuri-font-size-decrease",
  VERSURI_SIMILAR_CLICK: "versuri-similar-click",
  VERSURI_YOUTUBE_PLAY: "versuri-youtube-play",
  VERSURI_YOUTUBE_PAUSE: "versuri-youtube-pause",
  VERSURI_YOUTUBE_ENDED: "versuri-youtube-ended",

  // Song Player Events
  SONG_PLAYER_PLAY: "song-player-play",
  SONG_PLAYER_PAUSE: "song-player-pause",
  SONG_PLAYER_NEXT: "song-player-next",
  SONG_PLAYER_PREV: "song-player-prev",
  SONG_PLAYER_LOOP_TOGGLE: "song-player-loop-toggle",
  SONG_PLAYER_SHUFFLE_TOGGLE: "song-player-shuffle-toggle",
  SONG_PLAYER_SKIP_FORWARD: "song-player-skip-forward",
  SONG_PLAYER_SKIP_BACKWARD: "song-player-skip-backward",
  SONG_PLAYER_OPEN: "song-player-open",
  SONG_PLAYER_CLOSE: "song-player-close",
  SONG_PLAYER_CAST_CLICKED: "song-player-cast-clicked",

  // Demo Player Events
  DEMO_PLAY_CLICKED: "demo-play-clicked",
  DEMO_PAUSE_CLICKED: "demo-pause-clicked",

  // Navigation/CTA Events
  HERO_CTA_CLICK: "hero-cta-click",
  TESTIMONIALS_CTA_CLICK: "testimonials-cta-click",
  PRICING_CTA_CLICK: "pricing-cta-click",
  GALLERY_ORDER_CLICK: "gallery-order-click",
  GALLERY_PRICING_CLICK: "gallery-pricing-click",
  FAQ_CONTACT_CLICK: "faq-contact-click",

  // Contact Events
  CONTACT_EMAIL_CLICK: "contact-email-click",
  CONTACT_PHONE_CLICK: "contact-phone-click",
  CONTACT_WHATSAPP_CLICK: "contact-whatsapp-click",
  CONTACT_FAQ_CLICK: "contact-faq-click",
  WHATSAPP_FAB_CLICK: "whatsapp-fab-click",

  // Footer Events
  FOOTER_HOME_CLICK: "footer-home-click",
  FOOTER_ORDER_CLICK: "footer-order-click",
  FOOTER_GALLERY_CLICK: "footer-gallery-click",
  FOOTER_PRICING_CLICK: "footer-pricing-click",
  FOOTER_FAQ_CLICK: "footer-faq-click",
  FOOTER_BLOG_CLICK: "footer-blog-click",
  FOOTER_VERSURI_CLICK: "footer-lyrics-click",
  FOOTER_SUPPORT_CLICK: "footer-support-click",
  FOOTER_PHONE_CLICK: "footer-phone-click",
  FOOTER_EMAIL_CLICK: "footer-email-click",
  FOOTER_WHATSAPP_CLICK: "footer-whatsapp-click",

  // Gallery Events
  GALLERY_LINK_CLICK: "gallery-link-click",

  // Logo Events
  LOGO_CLICK: "logo-click",

  // Blog Page Events
  BLOG_DRIVE: "blog-drive",

  // Voucher Events
  VOUCHER_APPLIED: "voucher-applied",
  VOUCHER_REMOVED: "voucher-removed",
  VOUCHER_INVALID: "voucher-invalid",
  VOUCHER_REQUEST_TOPBAR_CLICKED: "voucher-request-topbar-clicked",
  VOUCHER_REQUEST_BUTTON_CLICKED: "voucher-request-button-clicked",
  VOUCHER_REQUEST_POPUP_CLOSED: "voucher-request-popup-closed",

  // User Activity Events
  HEARTBEAT: "heartbeat",
  USER_IDLE: "user-idle",
  USER_ACTIVE: "user-active",

  // Yoto Events
  YOTO_EXCLUDE: "yoto-exclude",
  YOTO_INCLUDE: "yoto-include",
  YOTO_TRACK_ICON_CHANGED: "yoto-track-icon-changed",
  YOTO_PIXEL_ART_GENERATED: "yoto-pixel-art-generated",

  // Viewport Events
  VIEWPORT_HOW_IT_WORKS: "viewport-how-it-works",
  VIEWPORT_GALLERY: "viewport-gallery",
  VIEWPORT_TESTIMONIALS: "viewport-testimonials",
  VIEWPORT_FOOTER: "viewport-footer",

  // Tracking Events
  FIRST_SEEN: "first-seen",
  APP_LOAD: "app-load",
  APP_BACK: "app-back",
  APP_HIDDEN: "app-hidden",
  APP_VISIBLE: "app-visible",

  // Notification Events
  NOTIFICATION_PUSH_OPEN: "notification-push-open",
  NOTIFICATION_PANEL_OPEN: "notification-panel-open",
  NOTIFICATION_BELL_CLICK: "notification-bell-click",
} as const;

export type AnalyticsEvent =
  (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];
